export default __webpack_public_path__ + "static/media/mobile-3.6712a831.png";